import { combineReducers } from 'redux'
import {
  TOGGLE_NAVIGATION_DRAWER,
} from './constants'
import {
  createReducer,
} from 'helpers/ReducerUtil'
import tabIndexReducer from 'containers/App/AppNavigation/reducer'

const toggleNavigationDrawer = (active) => !active

const activeReducer = createReducer(false, {
  [TOGGLE_NAVIGATION_DRAWER]: toggleNavigationDrawer,
})

const appReducer = combineReducers({
  tabIndex: tabIndexReducer,
  active: activeReducer
})

export default appReducer
